import MarkdownIt from "markdown-it";
import TurndownService from "turndown";

const turndownService = new TurndownService({
  emDelimiter: "*",
  blankReplacement: function (content, node) {
    if (node.nodeName === "P" && node.textContent?.replace(/\u00a0/g, "").trim() === "") {
      return "\n\n&nbsp;\n\n";
    }
    return "";
  },
});

// Convert <br> to line breaks
turndownService.addRule("lineBreaks", {
  filter: ["br"],
  replacement: () => "\n&nbsp;\n",
});

export function htmlToMarkdown(html: string): string {
  const safeHtml = preserveSpacesInHtml(html ?? "");
  const markdown = turndownService.turndown(safeHtml).trim();
  return markdown;
}

const md = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: false,
});

export function mdToHtml(markdown: string): string {
  return md.render(markdown ?? "");
}
function preserveSpacesInHtml(html: string): string {
  return html.replace(/ {2,}/g, (match) =>
    match
      .split("")
      .map(() => "&nbsp;")
      .join(""),
  );
}
